
    export enum EnumLabelType {
			None = 0,
			BaseProduct = 1,
			Flavor36Base = 2,
			InHouse = 3,
			IngredientGroup1 = 4,
			Ingredient = 5,
			Prdp1Base = 6,
			PrivateLabel = 7,
			InHouseAndPrivateLabel = 8,
			UkdIngredient1 = 9,
			UkdIngredient2 = 10,
			UkdIngredient3 = 11,
			UkdIngredient4 = 12,
			Repack = 13,
    }